import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useStatus, SUCCESS, ERROR } from '@rootstrap/redux-tools';

import useToast from 'hooks/useToast';
import useNavigation from 'hooks/useNavigation';
import { routeWithProps } from 'utils/helpers';
import { routesPaths } from 'constants/routesPaths';
import useSession from 'hooks/useSession';
import { updatePodcast } from 'state/actions/podcastActions';

export default callback => {
  const dispatch = useDispatch();
  const { status } = useStatus(updatePodcast);
  const { showErrorToast, showToast } = useToast();
  const { goToWithSearch } = useNavigation();
  const [isLoading, setIsLoading] = useState(false);
  const { user } = useSession();

  useEffect(() => {
    if (status === SUCCESS) {
      const route = routeWithProps(routesPaths.celebrityId, {
        username: user.username.toLowerCase()
      });
      goToWithSearch(route, `?tab=4`);
      showToast('Podcast Successfully updated!');
      dispatch(updatePodcast.reset());
      setIsLoading(false);
    }
    if (status === ERROR) {
      showErrorToast('Something went wrong!');
      dispatch(updatePodcast.reset());
      setIsLoading(false);
    }
  }, [callback, dispatch, showErrorToast, showToast, status]);

  const updatePodcastWithLoading = useCallback(
    (celebrityId, podcastId, podcast) => {
      setIsLoading(true);
      dispatch(updatePodcast(celebrityId, podcastId, podcast));
    },
    [dispatch]
  );

  return { updatePodcast: updatePodcastWithLoading, isLoading };
};
